import React, { useCallback, useState } from "react";
import { Card, CardBody, CardFooter } from "reactstrap";

import CommentList from "./list";
import CommentForm from "./form";

const CommentBox = props => {
  const {
    configuration: {
      defaultRequestParams,
      routes
    }
  } = props;

  const [comments, setComments] = useState([])

  const scrollDownContainer = useCallback(() => {
    const objDiv = document.getElementById('comment-box-container');
    objDiv.scrollTop = objDiv.scrollHeight;
  }, [])

  const pushComment = (comment) => {
    let _comments = [ ... comments ];
    _comments.push(comment);
    _comments = orderComments(_comments)

    setComments(_comments);
    scrollDownContainer();
  }

  const orderComments = useCallback((_comments) => {
    return _.sortBy(
      _.uniqBy(_comments, 'id'),
      'created_at')
  }, [])

  return (
    <Card>
      <CardBody>
        <CommentList
          comments={ comments }
          configuration={{
            defaultRequestParams,
            routes,
          }}
          data={ props?.data }
          callbacks={{
              scrollDownContainer,
              setComments,
              orderComments
          }}
        />
      </CardBody>

      <CardFooter>
        <CommentForm
          configuration={{
            defaultRequestParams,
            routes
          }}
          callbacks={{
            pushComment
          }}
        />
      </CardFooter>
    </Card>
  )
}

export default CommentBox;
